import { useQuery, useQueryClient } from 'react-query'
import { getJSON } from 'common/services/api'
import { GoalListResponse } from '@lmc/ts-common'
import useGoalsAccess from 'components/AccessControl/features/useGoalsAccess'
import { useCallback } from 'react'

const useGoals = (
  residentID: string | undefined,
  onSuccess?: (data: GetListQueryResponse) => void
) => {
  const hasGoals = useGoalsAccess()
  const queryClient = useQueryClient()

  const handleOnSuccess = useCallback((data: GetListQueryResponse) => {
    onSuccess?.(data)

    const goals = data.result

    goals?.forEach((goal) => {
      queryClient.setQueryData(['resident', residentID, 'goal', goal.id], {
        result: goal,
      })
    })
  }, [])

  const { isLoading, data, refetch } = useQuery<GetListQueryResponse>(
    `goals-resident-${residentID}`,
    () => getJSON({ url: getListQuery(residentID) }),
    {
      onSuccess: handleOnSuccess,
      enabled: hasGoals && Boolean(residentID),
    }
  )

  return {
    goals: data?.result,
    isLoading,
    refetch,
  }
}

export type GetListQueryResponse = {
  result?: GoalListResponse[]
}

const getListQuery = (residentId: string | undefined) =>
  `/api/list/residents/${residentId}/goals`
export default useGoals
